import { EmployeeDto } from "./employee.dto";
import { OvertimeDto } from "./overtime.dto";
import { PayPeriodDto } from "./pay-period.dto";

// Shared by work time and overtime requests
export enum TimeRequestStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
  CANCELLED = "CANCELLED",
  // Approved, then withdrawn before payroll used it
  REVOKED = "REVOKED",
}

export const TIME_REQUEST_STATUS_OPTIONS = Object.values(TimeRequestStatus);

export enum TimeRequestResponseType {
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
}

export type TimeRequestResponseDto = {
  id: number;
  approvingEmployeeId: number;
  comment: string;
  responseType: TimeRequestResponseType;
  approverLevel: number;
  createdAt: string;
  employee?: EmployeeDto;
};

export type TimeRequestBase = {
  id: number;
  employeeId: number;
  payPeriodId: number;
  status: TimeRequestStatus;
  createdAt: string;
  modifiedAt: string | null;
  statusLastModifiedAt: string | null;
  approvedAt: string | null;
  cancelledByEmployeeId: number | null;
  approvalsRequired: number;
  responseCompletedAt: string | null;
  cancelledAt: string | null;
  revokedAt: string | null;
  revokedByEmployeeId: number | null;
  revocationReason: string | null;
  employee?: EmployeeDto;
  payPeriod?: PayPeriodDto;
  // Approval level the next response is for
  currentLevel?: number;
  // Whether the current user can respond to it now
  canRespond?: boolean;
};

export class RevokeTimeRequestDto {
  reason!: string;
}

export type TimeRequestOptionsDto = {
  employeeId: number;
  // Work time can only be requested for an open pay period
  workTimePayPeriods: PayPeriodDto[];
  // Overtime from a recently closed pay period is paid in the next open one
  overtimePayPeriods: PayPeriodDto[];
  overtimes: OvertimeDto[];
};
